/*
 * Reliance — collections (sections rel-collection-*).
 * 1. Filtres de la grille des parfums par famille (+ liens « Voir la famille » des cartes famille).
 * 2. Questionnaire « Trouver mon accord » : 3 questions, accord recommandé + « À sentir aussi » (règles de
 *    _docs/specs/quiz-parfums.md), liens vers le récit de la grille et la superposition, sessionStorage.
 * 3. Superposition corps : les pastilles affichent le panneau de l'accord choisi ; dans la carte du geste 3,
 *    les pastilles Huile / Lait basculent photo, nom, prix et lien.
 * 4. Chapitres Soins corps : boutons précédent / suivant du carrousel (< 1040 px, scroll-snap en CSS ; à toutes
 *    les largeurs avec « Carrousel aussi sur ordinateur », compteur « 1–3 / 6 »).
 *    Sans JS, le carrousel reste utilisable au doigt et les boutons restent masqués.
 * 5. Chapitres en onglets (réglage « Groupes en onglets ») : un groupe affiché à la fois, flèches du clavier.
 */
(function () {
  if (window.relCollectionInit) return;
  window.relCollectionInit = true;

  function initFilter(root) {
    var chips = root.querySelectorAll('[data-rel-filter]');
    var cards = root.querySelectorAll('[data-rel-grid] > [data-family]');
    var empty = root.querySelector('[data-rel-grid-empty]');
    if (!chips.length) return;

    function apply(key) {
      var shown = 0;
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-rel-filter') === key ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        var match = key === 'all' || card.getAttribute('data-family') === key;
        card.hidden = !match;
        if (match) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-rel-filter'));
      });
    });

    root.querySelectorAll('[data-rel-family-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        apply(link.getAttribute('data-rel-family-link'));
      });
    });
  }

  /* Règles de _docs/specs/quiz-parfums.md (validée en l'état le 2026-09-24) : l'accord principal est la réponse
     de Q1 ; Q2 / Q3 ne choisissent que l'accord « À sentir aussi » et nuancent le texte. */
  var QUIZ_PAIRS = { eden: 'orangerie', orangerie: 'vie', vie: 'orangerie', rose: 'orient', ambre: 'vie', orient: 'ambre' };

  function quizAltKey(main, sillage, moment) {
    if (sillage === 'enveloppant' && ['eden', 'orangerie', 'vie'].indexOf(main) > -1) return 'ambre';
    if (sillage === 'discret' && ['orient', 'rose', 'ambre'].indexOf(main) > -1) return 'eden';
    if (moment === 'soir' && ['eden', 'orangerie'].indexOf(main) > -1) return 'rose';
    return QUIZ_PAIRS[main];
  }

  function initQuiz(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-rel-quiz-step]'));
    var result = root.querySelector('[data-rel-quiz-result]');
    var textsEl = root.querySelector('[data-rel-quiz-texts]');
    var storageKey = root.getAttribute('data-storage-key');
    var texts = {};
    try {
      texts = textsEl ? JSON.parse(textsEl.textContent) : {};
    } catch (e) {
      texts = {};
    }
    var state = { step: 0, answers: [null, null, null], done: false };

    try {
      var saved = storageKey && JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      if (saved && Array.isArray(saved.answers) && saved.answers.length === steps.length) {
        state.answers = saved.answers;
        state.step = Math.min(Math.max(parseInt(saved.step, 10) || 0, 0), steps.length - 1);
        state.done = !!saved.done && !!result && state.answers.every(Boolean);
      }
    } catch (e) {
      /* stockage indisponible : on repart de zéro */
    }

    function save() {
      if (!storageKey) return;
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch (e) {
        /* navigation privée ou stockage bloqué */
      }
    }

    function focusEl(el) {
      if (!el) return;
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    }

    function cardFor(attr, key) {
      return result ? result.querySelector('[' + attr + '="' + key + '"]') : null;
    }

    function firstKey(attr, except) {
      var list = result ? result.querySelectorAll('[' + attr + ']') : [];
      for (var i = 0; i < list.length; i++) {
        var k = list[i].getAttribute(attr);
        if (k !== except) return k;
      }
      return null;
    }

    /* Carte de la grille des parfums dont le lien pointe vers ce produit, et son récit dépliable. */
    function storyFor(handle) {
      var cards = document.querySelectorAll('[data-rel-grid] > [data-family]');
      for (var i = 0; i < cards.length; i++) {
        var link = cards[i].querySelector('a[href]');
        if (!link) continue;
        var path = link.pathname.replace(/\/$/, '');
        if (path.slice(-('/products/' + handle).length) === '/products/' + handle) {
          var details = cards[i].querySelector('details');
          return details ? { card: cards[i], details: details } : null;
        }
      }
      return null;
    }

    function openStory(handle) {
      var story = storyFor(handle);
      if (!story) return;
      if (story.card.hidden) {
        var all = document.querySelector('[data-rel-filter="all"]');
        if (all) all.click();
      }
      story.details.open = true;
      story.card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      focusEl(story.details.querySelector('summary'));
    }

    function renderResult() {
      var main = state.answers[0];
      if (!cardFor('data-rel-quiz-main', main)) main = firstKey('data-rel-quiz-main');
      var alt = quizAltKey(main, state.answers[1], state.answers[2]);
      if (!cardFor('data-rel-quiz-alt', alt) || alt === main) alt = firstKey('data-rel-quiz-alt', main);

      result.querySelectorAll('[data-rel-quiz-main]').forEach(function (card) {
        card.hidden = card.getAttribute('data-rel-quiz-main') !== main;
      });
      result.querySelectorAll('[data-rel-quiz-alt]').forEach(function (card) {
        card.hidden = card.getAttribute('data-rel-quiz-alt') !== alt;
      });

      var mainCard = cardFor('data-rel-quiz-main', main);
      var altCard = cardFor('data-rel-quiz-alt', alt);
      if (mainCard) {
        var why = mainCard.querySelector('[data-rel-quiz-why]');
        var parts = [why.getAttribute('data-line') || ''];
        if (texts.sillage && texts.sillage[state.answers[1]]) parts.push(texts.sillage[state.answers[1]]);
        if (state.answers[2] === 'soir' && texts.evening) parts.push(texts.evening);
        why.textContent = parts.filter(Boolean).join(' ');
      }
      if (altCard) {
        var why2 = texts.why || {};
        altCard.querySelector('[data-rel-quiz-alt-why]').textContent = why2[main + '>' + alt] || why2['x>' + alt] || '';
      }
      var note = result.querySelector('[data-rel-quiz-layer-note]');
      if (note && mainCard) note.textContent = mainCard.getAttribute('data-layer-note') || '';
      var layer = result.querySelector('[data-rel-quiz-layer]');
      if (layer) {
        layer.setAttribute('data-rel-quiz-layer', main);
        layer.hidden = !document.querySelector('[data-rel-layer="' + main + '"]');
      }
    }

    function render() {
      steps.forEach(function (step, i) {
        step.hidden = state.done || i !== state.step;
        var answer = state.answers[i];
        step.querySelectorAll('[data-rel-quiz-choice]').forEach(function (choice) {
          choice.setAttribute('aria-pressed', choice.getAttribute('data-rel-quiz-choice') === answer ? 'true' : 'false');
        });
        var next = step.querySelector('[data-rel-quiz-next]');
        if (next) next.disabled = !answer;
      });
      if (result) {
        result.hidden = !state.done;
        if (state.done) renderResult();
      }
    }

    function go(step, done) {
      state.step = step;
      state.done = done;
      save();
      render();
      if (done) focusEl(result.querySelector('[data-rel-quiz-result-label]'));
      else focusEl(steps[step].querySelector('legend'));
    }

    steps.forEach(function (step, i) {
      step.querySelectorAll('[data-rel-quiz-choice]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          state.answers[i] = choice.getAttribute('data-rel-quiz-choice');
          save();
          render();
        });
      });
      var next = step.querySelector('[data-rel-quiz-next]');
      if (next) {
        next.addEventListener('click', function () {
          if (!state.answers[i]) return;
          if (next.hasAttribute('data-rel-quiz-finish')) {
            if (result) go(i, true);
          } else if (i + 1 < steps.length) {
            go(i + 1, false);
          }
        });
      }
      var prev = step.querySelector('[data-rel-quiz-prev]');
      if (prev) {
        prev.addEventListener('click', function () {
          if (i > 0) go(i - 1, false);
        });
      }
    });

    if (result) {
      var restart = result.querySelector('[data-rel-quiz-restart]');
      if (restart) {
        restart.addEventListener('click', function () {
          state.answers = steps.map(function () {
            return null;
          });
          go(0, false);
        });
      }
      result.querySelectorAll('[data-rel-quiz-story]').forEach(function (button) {
        var handle = button.getAttribute('data-rel-quiz-story');
        button.hidden = !storyFor(handle);
        button.addEventListener('click', function () {
          openStory(handle);
        });
      });
      var layer = result.querySelector('[data-rel-quiz-layer]');
      if (layer) {
        layer.addEventListener('click', function () {
          var chip = document.querySelector('[data-rel-layer="' + layer.getAttribute('data-rel-quiz-layer') + '"]');
          if (!chip) return;
          chip.click();
          var section = chip.closest('[data-rel-layering]');
          (section || chip).scrollIntoView({ behavior: 'smooth', block: 'start' });
          focusEl(chip);
        });
      }
    }

    render();
  }

  function once(fn) {
    return function (root) {
      if (root.dataset.relReady) return;
      root.dataset.relReady = 'true';
      fn(root);
    };
  }

  function initLayering(root) {
    var chips = root.querySelectorAll('[data-rel-layer]');
    var panels = root.querySelectorAll('[data-rel-layer-panel]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.getAttribute('data-rel-layer');
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-rel-layer-panel') !== key;
        });
      });
    });

    root.querySelectorAll('[data-rel-texture-card]').forEach(function (card) {
      var toggles = card.querySelectorAll('[data-rel-texture]');
      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var key = toggle.getAttribute('data-rel-texture');
          toggles.forEach(function (t) {
            t.setAttribute('aria-pressed', t.getAttribute('data-rel-texture') === key ? 'true' : 'false');
          });
          card.querySelectorAll('[data-rel-texture-panel]').forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-rel-texture-panel') !== key;
          });
          /* Le bouton cliqué vient d'être masqué : le focus passe à son double dans la texture affichée. */
          var twin = card.querySelector('[data-rel-texture-panel="' + key + '"] [data-rel-texture="' + key + '"]');
          if (twin) twin.focus();
        });
      });
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-rel-carousel-track]');
    var controls = root.querySelector('[data-rel-carousel-controls]');
    var prev = root.querySelector('[data-rel-carousel-prev]');
    var next = root.querySelector('[data-rel-carousel-next]');
    var count = root.querySelector('[data-rel-carousel-count]');
    if (!track || !controls || !prev || !next) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      if (count) {
        var total = track.children.length;
        var size = step();
        var visible = Math.max(Math.floor((track.clientWidth + 2) / size), 1);
        var first = next.disabled ? Math.max(total - visible + 1, 1) : Math.round(track.scrollLeft / size) + 1;
        var last = Math.min(first + visible - 1, total);
        count.textContent = max > 2 && size > 0 ? (first === last ? first : first + '–' + last) + ' / ' + total : '';
      }
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* Carrousel dans un onglet masqué : les mesures valent 0 tant qu'il n'est pas affiché. */
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    controls.hidden = false;
    update();
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rel-tab]'));
    if (tabs.length < 2) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });
      tab.addEventListener('keydown', function (event) {
        var target = null;
        if (event.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') target = tabs[0];
        else if (event.key === 'End') target = tabs[tabs.length - 1];
        if (!target) return;
        event.preventDefault();
        select(target, true);
      });
    });

    /* Éditeur de thème : sélectionner un groupe affiche son onglet. */
    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest && event.target.closest('[role="tabpanel"]');
      if (!panel) return;
      tabs.forEach(function (t) {
        if (t.getAttribute('aria-controls') === panel.id) select(t, false);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-rel-coll-filter]').forEach(once(initFilter));
    document.querySelectorAll('[data-rel-quiz]').forEach(once(initQuiz));
    document.querySelectorAll('[data-rel-layering]').forEach(once(initLayering));
    document.querySelectorAll('[data-rel-carousel]').forEach(once(initCarousel));
    document.querySelectorAll('[data-rel-tabs]').forEach(once(initTabs));
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
